function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import "core-js/modules/es6.number.constructor.js";
import "core-js/modules/es6.symbol.js";
import "core-js/modules/es6.object.define-property.js";
import "core-js/modules/es6.object.keys.js";
import "core-js/modules/es6.array.filter.js";
import "core-js/modules/es6.object.get-own-property-descriptor.js";
import "core-js/modules/es6.array.for-each.js";
import "core-js/modules/es7.object.get-own-property-descriptors.js";
import "core-js/modules/es6.object.define-properties.js";
import "core-js/modules/es6.string.iterator.js";
import "core-js/modules/es6.object.to-string.js";
import "core-js/modules/es6.array.iterator.js";
import "core-js/modules/web.dom.iterable.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState } from 'vuex';
import n20ActionButtonMixin from './n20ActionButtonMixin';
export default {
  name: 'CoreN20Dialog',
  mixins: [n20ActionButtonMixin],
  props: {
    isOpen: {
      type: Boolean,
      "default": false
    },
    maxWidth: {
      type: [Number, String],
      "default": 900
    },
    persistent: {
      type: Boolean,
      "default": false
    },
    title: {
      type: String,
      "default": ''
    },
    actionSaveLabel: {
      type: String,
      "default": ''
    },
    actionSaveLoading: {
      type: Boolean,
      "default": false
    },
    actionSaveDisabled: {
      type: Boolean,
      "default": false
    }
  },
  data: function data() {
    return {};
  },
  computed: _objectSpread(_objectSpread({}, mapState('app', ['color', 'inpOutlined', 'inpFilled'])), {}, {
    cloading: function cloading() {
      return this.$store.state.app.loading;
    },
    isMobile: function isMobile() {
      return this.$vuetify.breakpoint.smAndDown;
    },
    hasCloseListener: function hasCloseListener() {
      return this.$listeners && this.$listeners.close;
    },
    hasSaveListener: function hasSaveListener() {
      return this.$listeners && this.$listeners['action:save'];
    }
  }),
  methods: {
    closeDialog: function closeDialog() {
      this.$emit('close');
    },
    closeOnEscape: function closeOnEscape(ev) {
      if (!this.persistent && ev.key === 'Escape') {
        this.closeDialog();
      }
    },
    closeOnClickOutSide: function closeOnClickOutSide() {
      if (!this.persistent) {
        this.closeDialog();
      }
    }
  }
};